import React from "react";
import { ReactDOM } from "react";

function Footer(){
    return(
        <div className="w-auto text-center p-1 text-gray-400">
            <p className="  text-lg ">
        Web Design By: Hemdinachi Ndu-Nwogu & Justin Etu 
        </p>
        <p> @tsucomputersociety</p>
        </div>
        
    )
}

export default Footer;